import { InputControlType as AmbassadorInputControlType } from '@wix/ambassador-events-v1-form/types';
import { InputControlType } from '@wix/events-types';
import { INPUT_CONTROLS, INPUT_NAMES } from './constants';
export const getInputControlMeta = (control) => {
    const { id, label } = control;
    const { name, additionalLabels, options, maxLength } = control.inputs[0];
    return {
        mandatory: isControlRequired(control),
        label,
        options,
        additionalLabels,
        maxLength,
        id,
        name,
    };
};
export const getFirstNameControlMeta = (control) => {
    const { id } = control;
    const { name, maxLength, label } = control.inputs[0];
    return {
        id,
        name,
        label,
        mandatory: isControlRequired(control),
        maxLength,
    };
};
export const getLastNameControlMeta = (control) => {
    const { id } = control;
    const { name, maxLength, label } = control.inputs[1];
    return {
        id,
        name,
        label,
        mandatory: isControlRequired(control),
        maxLength,
    };
};
export const getGuestNamesCaptions = (control) => control.inputs[1]?.additionalLabels ?? {};
export const getGuestNamesMaxLength = (control) => control.inputs[1]?.maxLength ?? 50;
export const isSystemControl = (control) => control.system;
export const getControlInputs = (control) => control.inputs;
export const getControlName = (control) => control.id.split('-')[0];
export const getControlType = (control) => control.type;
export const isAddressControl = (control) => isFullAddressControl(control) || isShortAddressControl(control);
export const isFullAddressControl = (control) => getControlType(control) === InputControlType.ADDRESS_FULL ||
    getControlType(control) === AmbassadorInputControlType.ADDRESS_FULL;
export const isShortAddressControl = (control) => getControlType(control) === InputControlType.ADDRESS_SHORT ||
    getControlType(control) === AmbassadorInputControlType.ADDRESS_SHORT;
export const isNameControl = (control) => getControlType(control) === InputControlType.NAME || getControlType(control) === AmbassadorInputControlType.NAME;
export const isDateControl = (control) => getControlType(control) === InputControlType.DATE || getControlType(control) === AmbassadorInputControlType.DATE;
export const isGuestsControl = (control) => getControlType(control) === InputControlType.GUEST_CONTROL ||
    getControlType(control) === AmbassadorInputControlType.GUEST_CONTROL;
export const isSingleGuestControl = (control) => getInputControlMeta(control).options.length === 2;
export const isCommentControl = (control) => getControlName(control) === INPUT_CONTROLS.COMMENT;
export const isEmailControl = (control) => getControlName(control) === INPUT_CONTROLS.EMAIL;
export const isControlRequired = (control) => {
    if (isGuestsControl(control)) {
        return !!control.inputs.find(input => input.name === INPUT_NAMES.GUEST_NAMES && input.mandatory);
    }
    return control.system || control.inputs.every(input => input.mandatory);
};
//# sourceMappingURL=selectors.js.map